export default {
  getList: {
    method: 'post',
    url: '/routing/list'
  },
  getAll: {
    method: 'post',
    url: '/routing/get-all'
  },
  get: {
    method: 'get',
    url: '/routing/id'
  },
  addRouting: {
    method: 'post',
    url: '/routing'
  },
  update: {
    method: 'put',
    url: '/routing'
  },
  delete: {
    method: 'delete',
    url: '/routing'
  }
  // updateRelationNode: {
  //   method: 'post',
  //   url: '/node/update-relation-node'
  // },
  // findNodes: {
  //   method: 'get',
  //   url: '/node/find?key=KEY&type=nodeType'
  // },
  // getHistory: {
  //   method: 'post',
  //   url: '/node/history/list'
  // },
  // getNodeTypes: {
  //   method: 'get',
  //   url: '/node/types'
  // },
  // getTransportTypes: {
  //   method: 'get',
  //   url: '/node/transport-types'
  // },
  // getNodeAndWareHouseTypes: {
  //   method: 'get',
  //   url: '/node/node-and-warehouse-types'
  // }
}
